import { gql } from '@apollo/client'

const qmrImDfmModal3dViewerQuery = gql`
    query qmrImDfmModal3dViewer($qmrId: UUID!, $showDeleted: Boolean) {
        quoteModelRevision(id: $qmrId, showDeleted: $showDeleted) {
            id
            dfmFeedback {
                id
                modelViewerSnapshots {
                    id
                    snapshot {
                        camera {
                            position
                            zoom
                            up
                            target
                        }
                        part {
                            transparent
                            patches {
                                color
                                hashcode
                            }
                        }
                        rotation
                        dfm {
                            color
                            threshold
                            feature
                            direction
                        }
                        annotations {
                            position
                        }
                        crossSection {
                            position
                            rotation
                        }
                        pointToPoint {
                            customPoints
                            selectedPoints {
                                index
                                type
                            }
                        }
                    }
                }
                sourceType
            }
            holes {
                id
                groupKey
                type
                depth
                diameter
                isBlind
                tipAngle
                counterboreDepth
                counterboreDiameter
                countersinkAngle
                countersinkDepth
                countersinkDiameter
                direction
                endPoint
                startPoint
                patches {
                    id
                }
                tapOptions {
                    id
                    maxDepth
                    commonName
                }
                tapAnnotation {
                    id
                    depth
                    tapOption {
                        id
                        maxDepth
                        commonName
                    }
                }
            }
            partRevision {
                id
                sceneBundle
            }
        }
    }
`

export default qmrImDfmModal3dViewerQuery
